// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"78359e337535fc7b7f87","655":"161fc50006dbcadd145b"}[chunkId] + ".js";
};